
<div *ngIf="isIEOrEdge" class="unsuported" [innerHTML]="'edgeTranslate' | transloco">

</div>

<header>
  <a routerLink="/home" id="logo" [class.left]="!loggedIn"></a>


  <div class="left-section">
    <ng-container *ngIf="loggedIn">
      <a (click.stop)="onSetHamburger(!showMenu, $event)" class="icon-hamburger d-block d-lg-none"></a>
      <div class="d-flex d-lg-none justify-content-center ml-auto" style="width: 40px; cursor: pointer">
          <span class="position-relative">
              <a class="position-relative fas fa-bell fa-lg" style="margin-top:25px"
              (click.stop)="onToggleNotifications(!showNotificationPane, $event)">                
              </a>
              <i class="unseen-badge" [class.has-unread]="notifications.unseen" style="right:2px !important;"></i>
          </span>
          <app-notification-pane [class.open]="showNotificationPane"></app-notification-pane>
      </div>
      <div id="help" class="d-lg-none d-flex" routerLinkActive="active" tabindex="0">
        <a [ngClass]="theme.name == 'Macrotech' ? 'icon-madih-info-circle' : 'fas fa-info-circle'" style="align-self: center; font-size: 2rem;"></a>
        <div class="nav-bucket" style="left: unset; right: 0">
          <a routerLink="faq" routerLinkActive="active" transloco="FAQ">FAQ</a>
          <a routerLink="privacyPolicy" routerLinkActive="active" transloco="privacy">Privacy Policy</a>
          <a *ngIf="!this.black_list.includes(theme.name)" (click)="onReportProblem()" transloco="reportAProblem">Report a Problem</a>
        </div>
      </div>
      <div id="profile" class="d-lg-none text-right" routerLinkActive="active" tabindex="0">
        <a class="pt-2 ab-primary" style="align-self:center;">
          <i class="fas fa-user fa-lg ab-primary"></i>          
        </a>
        <div class="nav-bucket" style="left: unset; right: 0">
          <a routerLink="profile" routerLinkActive="active" [state]="{ orderId: 1234 }" transloco="profile">Profile</a>
          <a routerLink="privacy_settings" routerLinkActive="active" transloco="privacySettings">Privacy Settings</a>
          <a transloco="logOut" (click)="onLogout()" id="logout">Log Out</a>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!loggedIn">
      <app-translation-input class="d-lg-none translation-style ml-auto p-0 px-sm-3"></app-translation-input>
      <div id="help" class="d-lg-none d-flex" routerLinkActive="active" tabindex="0">
        <a [ngClass]="theme.name == 'Macrotech' ? 'icon-madih-info-circle' : 'fas fa-info-circle'" style="align-self: center; font-size: 2rem;"></a>
        <div class="nav-bucket" style="left: unset; right: 0">
          <a routerLink="faq" routerLinkActive="active" transloco="FAQ">FAQ</a>
          <a routerLink="privacyPolicy" routerLinkActive="active" transloco="privacy">Privacy Policy</a>
          <a *ngIf="!this.black_list.includes(theme.name)" (click)="onReportProblem()" transloco="reportAProblem">Report a Problem</a>
        </div>
      </div>
    </ng-container>
  </div>

  <div @slide class="right-section" [class.slide]="showMenu">
    <ng-container *ngIf="loggedIn">
      <a routerLink="home" routerLinkActive="active" transloco="home">Home</a>
      <div routerLinkActive="active">
        <a routerLink="labs" routerLinkActive="active" transloco="laboratories">Laboratories</a>
        <div class="nav-bucket">
          <!-- transloco="mailbox" -->
          <a routerLink="labs/labs_list" routerLinkActive="active">Lab List</a>
        </div>
      </div>
      <div routerLinkActive="active">
        <a [routerLink]="hraCompleted? 'hra/results' : 'hra'" routerLinkActive="active" [ngbTooltip]="hraFullTemplate"
          placement="bottom" openDelay="1000" aria-label="Health Risk Assessment">
          <span class="d-none d-lg-inline position-relative">
            <span transloco="hra">HRA</span>
            <i class="unseen-badge" [class.has-unread]="!hraCompleted" style="top: 15px; right: -5px;"></i>
          </span>
          <span style="position: relative;">
            <span class="d-lg-none" transloco="hraFull">Health Risk Assessment</span>
            <i class="unseen-badge" [class.has-unread]="!hraCompleted" style="top: 15px; right: -5px;"></i>
          </span>
          <ng-template #hraFullTemplate><span transloco="hraFull"></span></ng-template>
        </a>
        <div class="nav-bucket show_on_mobile" *ngIf="hasResults">
          <a routerLink="hra/results" routerLinkActive="active" transloco="see_results">See Results</a>
        </div>
      </div>

      <div routerLinkActive="active" *ngIf="hasHealthplans">
        <a class="icon-caret-down" transloco="healthInsurance">Insurance</a>
        <div class="nav-bucket">
          <a routerLink="mailbox" routerLinkActive="active" transloco="mailbox">Mailbox</a>
        </div>
      </div>
      <a routerLink="health_records" routerLinkActive="active" transloco="healthFiles">Health Files</a>
      <a *ngIf="theme.name != 'Macrotech'" routerLink="maps" routerLinkActive="active" transloco="searchForDoctors">Find a Doctor</a>
      <div class="d-none d-lg-flex" style="width: 40px; cursor: pointer; ">
        <div class="d-none d-lg-block" routerLinkActive="active"></div>
        <span class="position-relative">
            <a class="position-relative fas fa-bell fa-lg" style="margin-top:25px;"
            (click.stop)="onToggleNotifications(!showNotificationPane, $event)">
            </a>
            <i class="unseen-badge" [class.has-unread]="notifications.unseen" style="right:2px !important;"></i>
        </span>
        <app-notification-pane [class.open]="showNotificationPane" style="left: unset; right: 0"></app-notification-pane>
      </div>

          <div class="d-none d-lg-flex" routerLinkActive="active">
            <a [ngClass]="theme.name == 'Macrotech' ? 'icon-madih-info-circle' : 'fas fa-info-circle'" style="align-self: center; font-size: 2rem;"></a>
            <div class="nav-bucket" style="left: unset; right: 0">
              <a routerLink="faq" routerLinkActive="active" transloco="FAQ">FAQ</a>
              <a routerLink="privacyPolicy" routerLinkActive="active" transloco="privacy">Privacy Policy</a>
              <a *ngIf="!this.black_list.includes(theme.name)" (click)="onReportProblem()" transloco="reportAProblem">Report a Problem</a>
            </div>
          </div>

      <div class="d-none d-lg-block" routerLinkActive="active">
        <a class="pt-2 ab-primary">
          <i class="fas fa-user fa-lg ab-primary"></i>
          <!-- <svg-icon icon="icon-profile" width="32" height="60" align="top" class="ab-primary"></svg-icon> -->
        </a>
        <div class="nav-bucket" style="left: unset; right: 0">
          <a routerLink="profile" routerLinkActive="active" transloco="profile">Profile</a>
          <a routerLink="privacy_settings" routerLinkActive="active" transloco="privacySettings">Privacy Settings</a>
          <a transloco="logOut" (click)="onLogout()" id="logout">Log Out</a>
        </div>
      </div>
      <app-translation-input class="translation-style mb-5 mb-lg-0"></app-translation-input>

      <span *ngIf="theme.whitelabel" style="line-height: 2"
            class="d-flex d-lg-none flex-column mt-auto p-4 small">
        <span transloco="poweredBy">Powered by</span>
        <img src="../../assets/patientlynk/img/PNG/logo-dark.png" style="max-width: 100px" />
      </span>
    </ng-container>

    <ng-container *ngIf="!loggedIn">
      <app-translation-input class="translation-style"></app-translation-input>
      <div class="d-none d-lg-flex" routerLinkActive="active">
        <a [ngClass]="theme.name == 'Macrotech' ? 'icon-madih-info-circle' : 'fas fa-info-circle'" style="align-self: center; font-size: 2rem;"></a>
        <div class="nav-bucket" style="left: unset; right: 0">
          <a routerLink="faq" routerLinkActive="active" transloco="FAQ">FAQ</a>
          <a routerLink="privacyPolicy" routerLinkActive="active" transloco="privacy">Privacy Policy</a>
          <a *ngIf="!this.black_list.includes(theme.name)" (click)="onReportProblem()" transloco="reportAProblem">Report a Problem</a>
        </div>
      </div>
    </ng-container>
  </div>

  <swal #swal [customClass]="{ container:'myToast' }" [swalFireOnInit]="false" [showConfirmButton]="false"
  [showCloseButton]="false" [toast]="true" (didClose)="handleDismiss()" position="top-end">
    <div *swalPortal style="display: flex;">
      <div class="swal2-icon swal2-info swal2-icon-show" style="display: flex;">
        <div class="swal2-icon-content">i</div>
      </div>

      <div style="display: flex; align-items: center;">
        <p style="font-weight: bold" class="text-center mx-3 my-0" transloco="newHRA">New HRA available</p>
        <button transloco="gotoHRA" class="mx-3 my-0 ab_button" (click)="goToHra()">Go to HRA</button>
      </div>

      <button type="button" class="swal2-close" aria-label="Close this dialog" style="display: flex;">×</button>
    </div>
  </swal>


  <swal #swalSMS [customClass]="{ container:'myToast' }" [swalFireOnInit]="false" [showConfirmButton]="false"
  [showCloseButton]="false" [toast]="true" (didClose)="handleSMSDismiss()" position="top-end">
          <div *swalPortal style="display: flex;">
            <div class="swal2-icon swal2-info swal2-icon-show" style="display: flex;">
              <div class="swal2-icon-content">i</div>
            </div>

            <div style="display: flex; align-items: center;"><p transloco="sms_alert.caption"></p>
              <button class="mx-3 my-0 ab_button" transloco="sms_alert.button" (click)="goToSMS()"></button>
            </div>

            <button type="button" class="swal2-close" aria-label="Close this dialog" style="display: flex;">×</button>
          </div>
      </swal>

</header>
